export type ApiErrorBody = {
  error?: {
    message?: string;
    code?: string;
    layer?: string;
    purpose?: string;
  };
};

function isApiErrorBody(data: unknown): data is ApiErrorBody {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  const message = (data as ApiErrorBody).error?.message;
  return typeof message === "string";
}

/** Reads `error.message` from a failed API response, or a status-based fallback. */
export async function readApiErrorMessage(
  res: Response,
  fallback?: string,
): Promise<string> {
  const defaultFallback = fallback ?? `Request failed (${res.status})`;

  try {
    const data: unknown = await res.json();
    if (isApiErrorBody(data)) {
      const message = data.error?.message?.trim();
      if (message) {
        return message;
      }
    }
  } catch {
    // Non-JSON or empty body — use fallback.
  }

  return defaultFallback;
}
